import { render, staticRenderFns } from "./folders-counterparties-files.vue?vue&type=template&id=265d9e1d&scoped=true"
import script from "./folders-counterparties-files.vue?vue&type=script&lang=js"
export * from "./folders-counterparties-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265d9e1d",
  null
  
)

export default component.exports